// src/utils/qr.js

export function parseQrPayload(input) {
  try {
    if (!input) return null;
    let s = String(input).trim();

    if (s.startsWith("{") && s.endsWith("}")) {
      return JSON.parse(s);
    }

    try {
      const url = new URL(s);
      const getFrom = (str) => new URLSearchParams(str).get("qr") || new URLSearchParams(str).get("data");
      let q = getFrom(url.search);
      if (!q) q = getFrom(url.hash.startsWith("#") ? url.hash.slice(1) : url.hash);
      if (q) {
        let raw = q;
        try { raw = decodeURIComponent(raw); } catch {}
        let jsonText = raw;
        const looksB64 = /^[A-Za-z0-9+/_-]+={0,2}$/.test(raw) && raw.length % 4 === 0;
        if (looksB64) {
          try { jsonText = atob(raw.replace(/-/g, "+").replace(/_/g, "/")); } catch {}
        }
        return JSON.parse(jsonText);
      }
    } catch {}

    try {
      const decoded = decodeURIComponent(s);
      if (decoded.startsWith("{") && decoded.endsWith("}")) {
        return JSON.parse(decoded);
      }
    } catch {}

    return null;
  } catch {
    return null;
  }
}
// === añade esto al final de src/utils/qr.js ===

// Construye una URL con el QR embebido (para descargar)
export function buildInventarioUrlWithQR(payload) {
  try {
    const json = JSON.stringify(payload);
    const encoded = encodeURIComponent(json);
    // apunta a la página de inventario de tu app
    return `${window.location.origin}/#qr=${encoded}`;
  } catch (e) {
    console.error("Error en buildInventarioUrlWithQR:", e);
    return "";
  }
}

// Descarga un QR con el nombre que se le pase
export function downloadQR(url, fileName = "QR.png") {
  try {
    const canvas = document.createElement("canvas");
    const size = 512;

    import("qrcode").then((QR) => {
      QR.toCanvas(canvas, url, { width: size, margin: 1 }, (err) => {
        if (err) throw err;
        const link = document.createElement("a");
        link.download = fileName;
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    });
  } catch (e) {
    console.error("Error al descargar QR:", e);
  }
}
